package br.com.texeratx.boardgametimeapp.core.session

import br.com.texeratx.boardgametimeapp.core.storage.TokenStorage
import br.com.texeratx.boardgametimeapp.data.model.login.UserSession

class SessionManager(
    private val tokenStorage: TokenStorage
) {

    suspend fun save(session: UserSession) {
        tokenStorage.saveSession(session)
    }

    suspend fun load(): UserSession? {
        return tokenStorage.getSession()
    }

    suspend fun clear() {
        tokenStorage.clear()
    }

    suspend fun logout() {
        val email = tokenStorage.getSession()?.email.orEmpty()
        tokenStorage.clear()
        if (email.isNotBlank()) {
            tokenStorage.saveSession(
                UserSession(
                    token = "",
                    userId = 0,
                    email = email,
                    displayName = ""
                )
            )
        }
    }

    suspend fun setActiveClan(
        clanId: Long,
        clanName: String,
        clanImageUrl: String?,
        role: String
    ) {
        val current = tokenStorage.getSession() ?: return
        tokenStorage.saveSession(
            current.copy(
                activeClanId = clanId,
                activeClanName = clanName,
                activeClanImageUrl = clanImageUrl,
                activeRole = role
            )
        )
    }

    suspend fun clearActiveClan() {
        val current = tokenStorage.getSession() ?: return
        tokenStorage.saveSession(
            current.copy(
                activeClanId = null,
                activeClanName = null,
                activeClanImageUrl = null,
                activeRole = null
            )
        )
    }
}
